var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11184_15087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.196 16.3005L15.276 15.4032C15.3284 14.8229 15.1679 14.2433 14.8244 13.7726C14.4809 13.302 13.9779 12.9723 13.4093 12.8452L11.1186 12.1032V9.06719C11.1186 8.74893 10.9922 8.4437 10.7672 8.21866C10.5421 7.99362 10.2369 7.86719 9.91864 7.86719C9.60038 7.86719 9.29516 7.99362 9.07011 8.21866C8.84507 8.4437 8.71864 8.74893 8.71864 9.06719V15.1005L7.35997 14.0792C7.12419 13.9016 6.83218 13.8151 6.5377 13.8357C6.24322 13.8563 5.96608 13.9825 5.7573 14.1912C5.54853 14.3999 5.42216 14.677 5.40145 14.9715C5.38075 15.266 5.46711 15.558 5.64464 15.7939L6.02397 16.2999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21411 9.5H1.71411C1.44889 9.5 1.19454 9.39464 1.007 9.20711C0.819468 9.01957 0.714111 8.76522 0.714111 8.5V1.5C0.714111 1.23478 0.819468 0.98043 1.007 0.792893C1.19454 0.605357 1.44889 0.5 1.71411 0.5H3.71411",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7141 0.5H12.7141C12.9793 0.5 13.2337 0.605357 13.4212 0.792893C13.6088 0.98043 13.7141 1.23478 13.7141 1.5V8.5C13.7141 8.76522 13.6088 9.01957 13.4212 9.20711C13.2337 9.39464 12.9793 9.5 12.7141 9.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.95 2.65039H5.94995",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.95 6.65039H5.94995",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44995 2.90039C3.31188 2.90039 3.19995 2.78846 3.19995 2.65039C3.19995 2.51232 3.31188 2.40039 3.44995 2.40039",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44995 2.90039C3.58802 2.90039 3.69995 2.78846 3.69995 2.65039C3.69995 2.51232 3.58802 2.40039 3.44995 2.40039",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44995 6.90039C3.31188 6.90039 3.19995 6.78846 3.19995 6.65039C3.19995 6.51232 3.31188 6.40039 3.44995 6.40039",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44995 6.90039C3.58802 6.90039 3.69995 6.78846 3.69995 6.65039C3.69995 6.51232 3.58802 6.40039 3.44995 6.40039",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11184_15087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.dd79a521.svg";
export { ForwardRef as ReactComponent };